import { useEffect, useState } from 'react';

/**
 * Devuelve `value` retrasado `delay` ms.
 * Uso: const qDeb = useDebounce(filters.q, 300);
 */
export function useDebounce(value, delay = 300) {
  const [debouncedValue, setDebouncedValue] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setDebouncedValue(value), delay);
    return () => clearTimeout(t);
  }, [value, delay]);
  return debouncedValue;
}

export default useDebounce;
